/*
$( ".menu-dropdown" ).mouseout(function(){
  $(".drawer__overlay").addClass("overlay_matt");
});
if ($('.drawer__overlay').hasClass("overlay_matt")) {
    $(".drawer__overlay").removeClass("overlay_matt");
}
*/

$(window).scroll(function(){
  var sticky = $('.header-desktop'),
      scroll = $(window).scrollTop();

  if (scroll >= 100) {
    sticky.addClass('header-sticky');
    $('.bwp-header').addClass('sticky');
  } else{
    sticky.removeClass('header-sticky');
    $('.bwp-header').removeClass('sticky');
  }
});